import type { CareSeekerShallowLeadFormDataV2 } from "~www/types/forms/care-seeker-shallow-lead-form";

function getCareSeekerDefaultValues({
  franchiseId = 0,
  postalCode = "",
}: {
  franchiseId?: number;
  postalCode?: string;
} = {}): Omit<CareSeekerShallowLeadFormDataV2, "urgency"> {
  return {
    careFor: "parent",
    careType: {
      everydayTasks: false,
      memoryCare: false,
      mobilityAssistance: false,
      other: false,
    },
    consentTerms: false,
    email: "",
    firstName: "",
    lastName: "",
    location: postalCode,
    OptInSms: false,
    organizationNumber: franchiseId,
    phone: "",
    postalCode: postalCode,
  };
}

export { getCareSeekerDefaultValues };
